import { COREBASEURL, QUERYBASEURL } from '../../constants/global';
import { electionType } from '../types';
import * as utils from './utils';

// const returnValue = (query: string, value: any) =>
//   value ? query + '' + value : ''

// const checkReturned = (data: string) => (data ? '?' + data : '')

export const getPoliticalPartiesAction = () =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'party',
			header: utils.headerNoAuth(),
		},
		actionType: electionType.getAllPoliticalParties,
	});

export const getAllActiveElections = () =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'Election/active',
			header: utils.headerNoAuth(),
		},
		actionType: electionType.getAllActiveElections,
	});

export const getAllElectionApplicationLinks = (electionId: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + `Party/get-links-for-election/${electionId}`,
			header: utils.headerNoAuth(),
		},
		actionType: electionType.getAllElectionApplicationLinks,
	});

// Fetches every published legal document (Terms, Privacy, GDPR/NDPR consent,
// Volunteer Code of Conduct) as a bare array. Surfaced in the data-consent
// gate's "Read the full …" dialogs.
export const getLegalDocumentsAction = () =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'Legal/documents/active',
			header: utils.headerNoAuth(),
		},
		actionType: electionType.getLegalDocuments,
	});

const returnValue = (query: string, value: any) => (value ? query + '' + value : '');

const checkReturned = (data: string) => (data ? '?' + data : '');

export const getElectionCycle = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				COREBASEURL +
				'ElectionCycle' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=pending',
			header: utils.headerNoAuth(),
		},
		actionType: electionType.electionCycle,
	});

export const getElection = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				COREBASEURL +
				'Election/paged' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=pending',
			header: utils.headerNoAuth(),
		},
		actionType: electionType.election,
	});

export const getElectionByName = (name: string) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'Election/name',
			header: utils.header(),
			data: JSON.stringify({ name }),
		},
		actionType: electionType.electionByName,
	});

export const getElectionCategory = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				COREBASEURL +
				'ElectiveCategory' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=pending',
			header: utils.headerNoAuth(),
		},
		actionType: electionType.electionCategories,
	});

export const primaryElectionsSearchAction = (data: { keywords: string[] }) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'Search',
			header: utils.header(),
			data: JSON.stringify(data),
		},
		actionType: electionType.primarySearch,
	});

export const tableSearchAction = (data: any) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: QUERYBASEURL + 'Result/get-all-multi-paged',
			header: utils.header(),
			data: JSON.stringify(data),
		},
		actionType: electionType.tableSearch,
	});
